class Helper {

    setCookie(cname, cvalue, exdays=0) {
        const d = new Date();
        let time = 30*60*1000;
        if(exdays != 0){
            time = exdays*24*60*60*1000;
        }
        d.setTime(d.getTime() + time);
        // let expires = "expires="+ d.toUTCString();
        let expires = "expires=0";
        document.cookie = cname + "=" + cvalue + "; "+expires+"; path=/";
    }

    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    deleteCookie(cname) {
        document.cookie = cname+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    setLocalStorage(cname, cvalue) {
        window.localStorage.setItem(cname, JSON.stringify(cvalue));
    }

    getLocalStorage(cname) {
        return JSON.parse(window.localStorage.getItem(cname));
    }

    deleteLocalStorage(cname) {
        window.localStorage.removeItem(cname);
    }
}

export default new Helper();